import './App.css';
import { useState } from 'react';
import Podcasts from './Podcasts';
import SplashScreen from './SplashScreen';

function App() {
    const [isSplashComplete, setIsSplashComplete] = useState(false);
    const [isLoadingPodcasts, setIsLoadingPodcasts] = useState(true);

    const handleSplashComplete = () => {
        setIsSplashComplete(true);
    };

    const handlePodcastsLoadComplete = () => {
        setIsLoadingPodcasts(false);
    };

    const showSplash = !isSplashComplete;
    const canExitSplash = !isLoadingPodcasts;
    const showContent = canExitSplash;

    return (
        <div className="App">
            {showSplash && (
                <SplashScreen
                    onComplete={handleSplashComplete}
                    canExit={canExitSplash}
                />
            )}
            <header
                className="App-header"
                style={{
                    display: 'block',
                    opacity: showContent ? 1 : 0,
                    transition: 'opacity 1s ease-in',
                    zIndex: showSplash ? 1 : 'auto'
                }}
            >
                <Podcasts onLoadComplete={handlePodcastsLoadComplete} />
            </header>
        </div>
    );
}

export default App;